import _ from 'lodash';

import { route } from '../helpers';
import urls from '../../urls';
import { JourneyPlannerLayout, GridPages, PointStages, GOTriggers } from '../../constants/AppConstants';
import SearchActions from '../../actions/SearchActions';
import TripActions from '../../actions/TripActions';
import JourneyStore from '../../stores/JourneyStore';
import UserStore from '../../stores/UserStore';
import CurrentTripStore from '../../stores/CurrentTripStore';
import FeatureVariantStore from '../../stores/FeatureVariantStore';
import { InvalidSearchError } from '../../errors/Search';

const getLayoutName = (version) => {
    switch (version) {
        case 1:
            return JourneyPlannerLayout.GRID_2;
        default:
            return JourneyPlannerLayout.GRID_2;
    }
};

module.exports = route(GridPages.SERVICES, {
    getComponent(location, cb) {
        require.ensure(
            [],
            (require) => {
                (async function () {
                    if (FeatureVariantStore.has('gridView')) {
                        await FeatureVariantStore.triggerEvent(GOTriggers.SERVICES_GRID);
                        await new Promise(resolve => FeatureVariantStore.waitForGO(resolve, resolve));
                    }

                    const componentVersion = FeatureVariantStore.get("gridViewVersion");
                    // eslint-disable-next-line no-console
                    console.info(
                        `%cLoading grid v${componentVersion + 1}`,
                        'color: white; background-color: blue; font-size: 1.5em',
                    );
                    const layoutName = getLayoutName(componentVersion);
                    switch (layoutName) {
                        case JourneyPlannerLayout.GRID_2:
                        default:
                            return cb(null, require('../../components/grid/v2/Services').default);
                    }
                })();
            },
            () => {
                // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
                // TODO: use a smarter way to get an updated chunk
                window.location.reload();
            },
            'services-grid');
    },

    async onComponentLoad (nextState, replace, callback, forcePlusBus = false) {
        const { params, location } = nextState;

        const refreshSearchFromUrl = async (targetLayout) => {
            const query = { ...location.query, targetLayout: targetLayout };
            let search = await SearchActions.loadFromParams(params, query);
            if (!search.isValid()) {
                replace(urls.location(PointStages.SEARCH, null, location.query));
            }

            const trip = CurrentTripStore.get();
            if (!JourneyStore.isCurrentSearch(search)) {
                try {
                    const user = UserStore.getCurrent();
                    await SearchActions.search({search, user});
                    if (trip.isPlusBusAvailable()) {
                        TripActions.loadPlusBusAvailability(trip);
                    }
                    _.defer(callback);
                } catch (e) {
                    replace(urls.location(PointStages.SEARCH, null, location.query));
                    if (e instanceof InvalidSearchError) {
                        console.error(e);
                    } else {
                        throw e;
                    }
                }
            } else if (trip.isPlusBusAvailable() && forcePlusBus) {
                TripActions.loadPlusBusAvailability(trip);
            }
            _.defer(callback);
        };

        (async function () {
            if (FeatureVariantStore.has('gridView')) {
                await FeatureVariantStore.triggerEvent(GOTriggers.SERVICES_GRID);
                await new Promise(resolve => FeatureVariantStore.waitForGO(resolve, resolve));
            }

            const componentVersion = FeatureVariantStore.get("gridViewVersion");
            return refreshSearchFromUrl(getLayoutName(componentVersion));
        })();
    },

    async onEnter (nextState, replace, callback) {
        this.onComponentLoad(nextState, replace, callback, true);
    },

    async onChange (prevState, nextState, replace, callback) {
        this.onComponentLoad(nextState, replace, callback);
    }
});



// WEBPACK FOOTER //
// ./src/routes/Grid/Services.js